import instance from "../../services/api";

export const reportTeachFeature = (params = {}) => {
  return instance(true).post("/partner/tech_features/remont_works/", params);
};

export const getJKList = () => {
  return instance(true).get("/partner/read_resident_by_contractor/");
};
